import { setAddress } from 'src/state/address/address-slice';
import {
  selectSelectedAddressId,
  selectServiceLocationsOrThrow,
  selectUserDetailsOrThrow,
} from 'src/state/address/selectors';
import { resetRequestsForNewAddressActionCreator } from 'src/state/request/action-creators';
import { AppDispatch, RootState } from 'src/state/types';
import { DataLayerUtils } from 'src/utils/data-layer-utils';
import { ServiceLocationsUtils } from 'src/utils/service-locations-utils';

export const selectAddressActionCreator = (id: number) => (dispatch: AppDispatch, getState: () => RootState) => {
  const rootState = getState();
  const selectedAddress = selectSelectedAddressId(rootState);
  const serviceLocations = selectServiceLocationsOrThrow(rootState);
  const postalCode = ServiceLocationsUtils.getSelectedServiceLocation(serviceLocations, id)?.address.postalCode || '';
  const userDetails = selectUserDetailsOrThrow(rootState);
  const { partnerNumber } = userDetails;

  if (selectedAddress && selectedAddress !== id) {
    dispatch(resetRequestsForNewAddressActionCreator());
  }

  dispatch(setAddress(id));
  DataLayerUtils.setCustomerCityDataLayer(postalCode, partnerNumber);
};
